export default {
    // Main
    title: 'Goal Forecast',
    maintainTitle: 'Weight Maintenance',

    // States
    noData: 'Complete a few days of your plan and log your weight to see your goal forecast.',
    calculate: 'Calculate Now',
    calculating: 'Calculating...',
    updating: 'Updating...',

    // Labels
    start: 'Start',
    current: 'Current',
    currentWeight: 'Current Weight',
    target: 'Target',
    targetWeight: 'Target Weight',
    goal: 'Goal',
    goalLabel: 'GOAL',
    you: 'YOU',
    complete: 'Complete',

    // Goal-specific
    lossRate: 'Loss Rate',
    gainRate: 'Gain Rate',
    pace: 'Pace',
    week: 'week',
    toGo: 'to go',
    toGain: 'to gain',

    // Projected date
    projectedDate: 'Projected Goal Date',
    days: 'days',
    weeks: 'weeks',

    // Stats
    confidence: 'Confidence',
    logs: 'Logs',

    // Status
    ahead: 'Ahead of Schedule',
    onTrack: 'On Track',
    behind: 'Slightly Behind',
    stalled: 'Progress Stalled',
    insufficientData: 'Gathering Data',

    // Maintain
    maintainingWell: 'Maintaining Well',
    adjustNeeded: 'Slight Adjustment Needed',
    maintainInfo: 'About Weight Maintenance',
    maintainInfoDesc: 'Maintenance means keeping your weight stable within a healthy range. Small fluctuations are normal!',
    maintainTolerance: 'Tolerance Range',
    maintainToleranceDesc: 'Staying within ±1 kg of your target weight is considered excellent maintenance.',
    maintainSuccessMsg: 'You\'re maintaining your weight perfectly. Keep up the great work!',
    maintainAboveMsg: 'You\'re slightly above your target. Consider reducing calories a bit.',
    maintainBelowMsg: 'You\'re slightly below your target. Consider increasing calories a bit.',
    maintenanceRange: 'Maintenance Range',
    variance: 'Variance',
    ideal: 'ideal',

    // Messages
    stalledMessage: 'Your progress has stalled. Consider adjusting your calorie intake or activity level.',
    behindMessage: 'You\'re slightly behind schedule. Stay consistent and you\'ll get back on track!',

    // Info modal
    howItWorks: 'How Goal Forecast Works',
    infoTheoryTitle: 'Your Nutrition Plan (Theory)',
    infoTheoryDesc: 'Expected weight change from your current calorie',
    infoTheoryDescDeficit: 'deficit',
    infoTheoryDescSurplus: 'surplus',
    infoRealityTitle: 'Your Actual Progress (Reality)',
    infoRealityDesc: 'Your real weight trend over the past weeks.',
    infoBlendingTitle: 'Intelligent Blending',
    infoBlendingEarly: 'Early',
    infoBlendingLater: 'Later',
    moreTheory: 'More theory',
    moreReality: 'More reality',
    infoStabilityTitle: 'Stability Protection',
    infoStabilityDesc: 'Your date won\'t jump around from day-to-day fluctuations. Only consistent trends shift the forecast.',
    infoImportantTitle: 'Important',
    infoImportantDesc: 'This is a forecast, not a guarantee. Continue your plan to stay on track!',

    // Goal reached
    goalReachedTitle: 'Goal Reached!',
    congratulations: 'Congratulations!',
    goalReachedMessage: 'You\'ve successfully reached your target weight. Amazing work!',
    startWeight: 'Start Weight',
    totalLost: 'Total Lost',
    totalGained: 'Total Gained',
    daysOnPlan: 'Days on Plan',
    whatsNext: 'What\'s Next?',
    nextStepsMessage: 'Consider setting a new goal or switching to maintenance mode to keep your results.',
};